export const TOKEN_IGNORE_APIS = [
	"/api/user/authenticate",
	"/api/user/forget-password/send-email",
	"/api/user/signup",
	"/api/user/forget-reset-password",
];
